(function () {
  'use strict';

  var loadedApps = {};
  var marketingAllowed = false;
  var statisticsAllowed = false;

  var blockedMarketingScriptPatterns = [
    'extensions/019f6011-640e-73f2-b6ed-9f8b071fa729/1click-popup-69',
    'cdn.growthhero.io/sites/pixel.js',
    'kochalpin.activehosted.com/js/site-tracking.php'
  ];

  var blockedStatisticsScriptPatterns = [
    'extensions/019f6a85-a63e-744c-b8c4-7bca667526fa/easylocation-269'
  ];

  function matchesPattern(src, patterns) {
    return patterns.some(function (pattern) {
      return src.indexOf(pattern) !== -1;
    });
  }

  function isBlockedScript(node) {
    if (!node || node.tagName !== 'SCRIPT') {
      return false;
    }

    var src = node.src || node.getAttribute('src') || '';

    if (!marketingAllowed && matchesPattern(src, blockedMarketingScriptPatterns)) {
      return true;
    }

    if (!statisticsAllowed && matchesPattern(src, blockedStatisticsScriptPatterns)) {
      return true;
    }

    return false;
  }

  function blockAutomaticScripts() {
    var originalAppendChild = Node.prototype.appendChild;
    var originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.appendChild = function (node) {
      if (isBlockedScript(node)) {
        return node;
      }

      return originalAppendChild.call(this, node);
    };

    Node.prototype.insertBefore = function (node, referenceNode) {
      if (isBlockedScript(node)) {
        return node;
      }

      return originalInsertBefore.call(this, node, referenceNode);
    };
  }

  function loadScriptOnce(name, src, attributes) {
    if (loadedApps[name] || document.querySelector('[data-consent-controlled-app="' + name + '"]')) {
      return;
    }

    loadedApps[name] = true;

    var script = document.createElement('script');
    script.src = src;
    script.setAttribute('data-consent-controlled-app', name);

    Object.keys(attributes || {}).forEach(function (attribute) {
      script[attribute] = attributes[attribute];
    });

    script.addEventListener('error', function () {
      loadedApps[name] = false;

      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }, { once: true });

    document.head.appendChild(script);
  }

  function loadOneClickPopup() {
    window.OneClickPopup = window.OneClickPopup || {};

    loadScriptOnce(
      'one-click-popup',
      'https://cdn.shopify.com/extensions/019f6011-640e-73f2-b6ed-9f8b071fa729/1click-popup-69/assets/1click-popup-snippet.js',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadGrowthHero() {
    loadScriptOnce(
      'growth-hero',
      'https://cdn.growthhero.io/sites/pixel.js?shop=snowline-shop.myshopify.com',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadActiveCampaign() {
    loadScriptOnce(
      'active-campaign',
      'https://cdn.shopify.com/proxy/db459d0401a5090a8519c6b8c4f604aec0effc0d1d8991d2879ee6849ec4a81e/kochalpin.activehosted.com/js/site-tracking.php?shop=snowline-shop.myshopify.com&sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadEasyLocation() {
    loadScriptOnce(
      'easy-location',
      'https://cdn.shopify.com/extensions/019f6a85-a63e-744c-b8c4-7bca667526fa/easylocation-269/assets/easylocation-storefront.min.js',
      { type: 'text/javascript' }
    );
  }

  function applyConsent(preferences) {
    if (!preferences) {
      return;
    }

    if (preferences.marketing) {
      if (!marketingAllowed) {
        marketingAllowed = true;
        loadOneClickPopup();
        loadGrowthHero();
        loadActiveCampaign();
      }
    } else if (marketingAllowed) {
      window.location.reload();
      return;
    }

    if (preferences.statistics) {
      if (!statisticsAllowed) {
        statisticsAllowed = true;
        loadEasyLocation();
      }
    } else if (statisticsAllowed) {
      window.location.reload();
      return;
    }
  }

  document.addEventListener('consentmoSignal', function (event) {
    applyConsent(event.detail && event.detail.preferences);
  });

  document.addEventListener('consentmoSignal_onLoad', function (event) {
    var consentmoState = event.detail || { isActive: false };

    if (!consentmoState.isActive) {
      marketingAllowed = true;
      statisticsAllowed = true;
      loadOneClickPopup();
      loadGrowthHero();
      loadActiveCampaign();
      loadEasyLocation();
    }
  });

  blockAutomaticScripts();
})();
